module.exports = __webpack_public_path__ + "img/102.5d72393c.jpg";